import { render, staticRenderFns } from "./SobreNos.vue?vue&type=template&id=d47fd97e&scoped=true&lang=pug"
import script from "./SobreNos.vue?vue&type=script&lang=js"
export * from "./SobreNos.vue?vue&type=script&lang=js"
import style0 from "./SobreNos.styl?vue&type=style&index=0&id=d47fd97e&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47fd97e",
  null
  
)

export default component.exports